import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/lib/auth";
import { chooseUiLanguage } from "@/lib/uiLang";

const GRAD = "linear-gradient(135deg, #8b5cf6 0%, #3b82f6 50%, #ec4899 100%)";

// FR | EN segmented switch; persists the choice locally and on the account.
export const LangPill = ({ className = "", idPrefix = "lang" }) => {
  const { i18n, t } = useTranslation();
  const { user, setUser } = useAuth() || {};
  const cur = i18n.language?.startsWith("fr") ? "fr" : "en";
  const switchTo = (lang) => chooseUiLanguage(lang, user, setUser);
  return (
    <div
      className={`inline-flex items-center rounded-full border p-0.5 text-[11.5px] font-bold ${className}`}
      role="group"
      aria-label={t("lp.lang_label")}
      style={{ fontFamily: "Outfit, sans-serif" }}
      data-testid={`${idPrefix}-switch`}
    >
      {["fr", "en"].map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => switchTo(l)}
          aria-pressed={cur === l}
          className={`h-7 px-2.5 rounded-full uppercase tracking-wide transition-colors ${
            cur === l ? "text-white" : "text-muted-foreground hover:text-foreground"
          }`}
          style={cur === l ? { background: GRAD } : undefined}
          data-testid={`${idPrefix}-${l}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};

export default LangPill;
